<template>
  <b-modal
    title="Add Synonym"
    ref="add-synonym-modal"
    id="add-synonym-modal"
    size="lg"
    ok-title="Add"
    @ok="addSynonym"
  >
    <b-card class="m-0" style="font-family: NanumBarunGothic;">
      <validation-observer ref="addSynonymRule" tag="form">
        <b-form-group label-for="synonym">
          <div style="display:inline-block; width: 10%;">KEYWORD<span class="text-danger">*</span></div>
          <validation-provider
            #default="{ errors }"
            name="Keyword"
            rules="required"
          >
          <b-form-input
            id="keyword"
            v-model="synonym.keyword"
            placeholder="대표 키워드"
            style="display:inline-block; width:43%; margin-left:1rem;"
            :state="errors.length > 0 ? false : null"
          />
          <small class="text-danger">{{ errors[0] }}</small>
          </validation-provider>
        </b-form-group>


        <b-row class="my-1">
          <b-col md="12">
            SYNONYM
            <feather-icon
              variant="primary"
              icon="PlusCircleIcon"
              class="cursor-pointer ml-1"
              size="18"
              ref="btn"
              @click="plusSynonym"
            />
          </b-col>
        </b-row>
        <b-form
          ref="form"
          class="repeater-form"
          @submit.prevent="addSynonym"
        >
          <b-row
            v-for="(item, index) in synonyms"
            :key="index"
            ref="row"
            class="d-flex align-items-center"
          >
            <b-col md="1"></b-col>
            <b-col md="7">
                <b-form-group label-for="synonym" class="ml-2" style="margin-top: 1rem;">
                  <b-form-input
                    v-model="item.synonym"
                  />
                </b-form-group>
            </b-col>
            
            <b-col md="1">
              <feather-icon
                variant="primary"
                icon="MinusCircleIcon"
                class="cursor-pointer"
                size="18"
                ref="btn"
                @click="minusSynonym(index)"
              />
            </b-col>
          </b-row>
        </b-form>






      </validation-observer>
    </b-card>
  </b-modal>
</template>

<script>
import { BCard, BFormGroup, BFormInput, BCol, BRow, BForm } from "bootstrap-vue";
import vSelect from "vue-select";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import CISSettingService from '@/services/cis-setting.service'

export default {
  name: "AddSynonymModal",
  components: {
    BCol, 
    BRow, 
    BForm,
    BCard,
    BFormGroup,
    BFormInput,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    refreshData: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      synonym: {},
      required,
      synonyms: [{
        synonym: ""
      }],
    };
  },
  watch: {
    
  },
  methods: {
    plusSynonym() {
      this.synonyms.push({synonym:""});
    },
    minusSynonym(index) {
      this.synonyms.splice(index, 1);
    },

    checkInfo() {
      return new Promise((resolve, reject) => {
        this.$refs.addSynonymRule.validate().then((success) => {
          if (success) {
            resolve(true);
          } else {
            reject("");
          }
        });
      });
    },
    async addSynonym(e) {
      e.preventDefault();
      await this.checkInfo();

      var synonym_arr = [];
      for(const item of this.synonyms) {
        if(item.synonym != ''){
          synonym_arr.push(item.synonym)
        }
      }
      this.synonym.synonym = synonym_arr.join();

      this.$swal({
        title: "Are you sure?",
        html: `You want to add the Synonym!<br>&nbsp;`,
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
        padding: "1rem",
      }).then(async (result) => {
        if (result.isConfirmed) {
          var ctgSq = this.$store.getters.getSelectedCategory
          if(ctgSq == '9999'){
            ctgSq = 1
          }
          this.synonym.ctgSq = ctgSq
          const response = await CISSettingService.addSynonym(this.synonym);
            if (response && response.status === 200) {
              this.synonym = {};
              this.synonyms = [];
              this.$bvModal.hide("add-synonym-modal");
              this.refreshData();
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: `Successfully added!`,
                  icon: "EditIcon",
                  variant: "success",
                },
              });
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: response.data.message || "Unknown error",
                  icon: "AlertCircleIcon",
                  variant: "danger",
                },
              });
            }
        }
      });
    },
  },
  created() {
  },
};
</script>

<style>

.modal-lg,
.modal-xl {
  max-width: 1100px;
}

</style>